module.exports = __webpack_public_path__ + "img/W-16.34a7bfe8.jpg";